const btnGenreData = [
    {
        _id : 1,
        title : "All",
        active : true
    },
    {
        _id : 2,
        title : "Romance",
        active : false
    },
    {
        _id : 3,
        title : "Action",
        active : false
    },
    {
        _id : 4,
        title : "Thriller",
        active : false
    },
    {
        _id : 5,
        title : "Horror",
        active : false
    },
    {
        _id : 6,
        title : "Adventure",
        active : false
    },
]
export default btnGenreData